"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.barChart = void 0;
var barChart = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"
    }
  }]
};
exports.barChart = barChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/fa/barChart.js
// module id = 1099
// module chunks = 0